// extracted by mini-css-extract-plugin
module.exports = {"primaryMain":"#035164","secondaryMain":"#007faa"};